import { ButtonType, ButtonWidget } from '@tableau/widgets';
import * as React from 'react';

import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { imgUrl } from '../../common/utilities/ImgUrl';
import { cssClass, flexColumnStyle, flexRowStyle } from '../../style';
import { TextileHelper } from '../../ts/helpers/TextileHelper';
import { FlowDetailInfo } from '../../ts/models/FlowInfo';
import { ChangeFlowDescriptionAction } from '../../ts/services/ChangeFlowDescriptionAction';
import { openEditFlowDescriptionDialog } from '../utils/FlowDialogUtils';
import { buttonClass } from './FlowTags';

const cssPrefix = 'FlowDescription';

const rootClass = cssClass(cssPrefix, 'root', flexColumnStyle);

const headerClass = cssClass(cssPrefix, 'header', flexRowStyle, {
  fontWeight: 'normal',
  fontSize: CommonStyles.Sizes.HeaderFontSize
});

const descriptionContainer = cssClass(cssPrefix, 'description', {
  paddingLeft: 2
});

const noDescription = cssClass(cssPrefix, 'noDescription', {
  paddingTop: CommonStyles.Sizes.DefaultSpace,
  paddingBottom: CommonStyles.Sizes.DefaultSpace
});

export type FlowDescriptionProps = {
  readonly flowDetailInfo: FlowDetailInfo;
  readonly editDescriptionAllowed: boolean;
  readonly refreshContext: () => void;
};

export class FlowDescription extends React.PureComponent<FlowDescriptionProps> {

  private changeFlowDescriptionAction: ChangeFlowDescriptionAction;
  private sanitize: ng.sanitize.ISanitizeService;

  constructor(props: FlowDescriptionProps) {
    super(props);
    this.changeFlowDescriptionAction = ServiceLocator.get<ChangeFlowDescriptionAction>('ChangeFlowDescriptionAction');
    this.sanitize = ServiceLocator.get<ng.sanitize.ISanitizeService>('$sanitize');
  }

  private toggleEditing = () => {
    openEditFlowDescriptionDialog(this.props.flowDetailInfo, this.handleSubmit).then(() => this.props.refreshContext());
  }

  private handleSubmit = (text: string): ng.IPromise<any> => {
    return this.changeFlowDescriptionAction.execute(this.props.flowDetailInfo, text).then(
      () => {
        this.props.refreshContext();
      }
    );
  }

  public render() {
    return (
      <div className={rootClass}>
        <div className={headerClass}>
          <div>{Messages.description()}</div>
          { this.props.editDescriptionAllowed ?
            <div className={buttonClass} title={Messages.editDescription()} onClick={this.toggleEditing}/> : null }
        </div>
        <div className={descriptionContainer}>
          {this.props.flowDetailInfo.description ?
            <div className={'tb-textile'} dangerouslySetInnerHTML={{__html: TextileHelper.getSanitizedHtmlFromTextile(this.props.flowDetailInfo.description, this.sanitize)}}/>
          : <div className={noDescription}>{Messages.flowOverviewNoDescription()}</div>}
        </div>
      </div>
    );
  }
}
